import React, { useState } from 'react'
import { IconButton, Tooltip } from '@mui/material'
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined'
import { useAppTranslations } from '../../../../utils/hooks/useAppTranslations'
import OverallBudgetCalculatorDialog from './OverallBudgetCalculatorDialog'

interface OverallBudgetCalculatorButtonProps {
  disabled?: boolean
}

const OverallBudgetCalculatorButton: React.FC<OverallBudgetCalculatorButtonProps> = ({ disabled = false }) => {
  const t = useAppTranslations()
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  return (
    <>
      <Tooltip title={t('adgroup.budgetAndDates.overallCalculator.open')}>
        <span>
          <IconButton
            color="primary"
            onClick={() => setIsDialogOpen(true)}
            disabled={disabled}
            aria-label={t('adgroup.budgetAndDates.overallCalculator.open')}
            sx={(theme) => ({
              p: theme.spacing(1),
              minWidth: theme.spacing(4.5),
              minHeight: theme.spacing(4.5),
            })}
          >
            <CalculateOutlinedIcon />
          </IconButton>
        </span>
      </Tooltip>

      <OverallBudgetCalculatorDialog open={isDialogOpen} setOpen={setIsDialogOpen} />
    </>
  )
}

export default OverallBudgetCalculatorButton
